<script>
const ageColors = {
  0: 'green',
  1: 'green',
  2: 'light-blue',
  3: 'orange',
  4: 'yellow',
  5: 'purple',
  6: 'blue'
}

export default {
  functional: true,
  name: 'age-badge',
  props: {
    age: Number
  },
  render(createElement, { props, children }) {
    const classes = [ 'age-badge' ]
    let ageColor = ageColors[props.age] || 'blue'
    classes.push(ageColor)

    return createElement('div', { class: classes }, props.age + '+')
  }
}
</script>

<style lang="scss">
.age-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(max(18px, 1.8rem), 26px);
  height: min(max(18px, 1.8rem), 26px);
  border-radius: 4px;
  font-size: 1.2rem;
  margin-right: 10px;
  padding: 2px 4px;
  color: #FFF;

  &.green {
    background-color: $age-badge-green-background;
  }

  &.light-blue {
    background-color: $age-badge-light-blue-background;
  }

  &.orange {
    background-color: $age-badge-orange-background;
  }

  &.yellow {
    background-color: $age-badge-yellow-background;
    color: #000;
  }

  &.purple {
    background-color: $age-badge-purple-background;
  }

  &.blue {
    background-color: $age-badge-blue-background;
  }
}
</style>
